// Adapted from build/src/client/components/viewers/index.ts
import { lazy } from 'react';

// ---------------------------------------------------------------------------
// Lazy-loaded viewers
// ---------------------------------------------------------------------------
// pdf.js, mammoth and SheetJS are large; loading each viewer on demand keeps
// them out of the app's initial bundle. Only the knowledge document page
// renders them.

export const LazyPdfViewer = lazy(() =>
  import('./PdfViewer').then((m) => ({ default: m.PdfViewer })),
);

export const LazyDocxViewer = lazy(() =>
  import('./DocxViewer').then((m) => ({ default: m.DocxViewer })),
);

export const LazyXlsxViewer = lazy(() =>
  import('./XlsxViewer').then((m) => ({ default: m.XlsxViewer })),
);

export const LazyCsvViewer = lazy(() =>
  import('./CsvViewer').then((m) => ({ default: m.CsvViewer })),
);
